module.exports = __webpack_public_path__ + "static/media/web_traffic.a59435b3.png";